import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; value_modules: number; value_metric_types: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; every_value_traceable: boolean; every_metric_explainable: boolean;
  roi_operational: boolean; executive_reports_operational: boolean;
  benchmarks_operational: boolean; performance_budgets_met: boolean; gaps?: string[];
};

export type Cvd001Status = {
  sprint_id: string; objectives: number; value_modules: number; value_metric_types: number;
  customer_value: boolean; roi_engine: boolean; executive_reports: boolean;
  renewal_center: boolean; benchmarking: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const customerValueCvd001Api = {
  dashboard: () => fetchG<SprintDashboard>('/cvd001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/cvd001/objectives').then((r) => r.objectives),
  valueModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/cvd001/value-modules').then((r) => r.modules),
  metricTypes: () => fetchG<{ metric_types: { key: string; name: string; category: string }[] }>('/cvd001/metric-types').then((r) => r.metric_types),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/cvd001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/cvd001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/cvd001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/cvd001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Cvd001Status>('/cvd001/status'),
};
